import { createSelector } from '@reduxjs/toolkit';

const selectUI = (state) => state.ui;

export const selectCBFriendly = createSelector(
  selectUI,
  (state) => state.cbfriendly
);

export const selectOverviewTab = createSelector(
  selectUI,
  (state) => state.overviewTab
);

export const selectInfoModal = createSelector(
  selectUI,
  (state) => state.infoModal
);

export const selectIsChartVisible = createSelector(
  selectUI,
  (state) => state.isChartVisible
);

export const selectIsEpisodeTimelineVisible = createSelector(
  selectUI,
  (state) => state.isEpisodeTimelineVisible
);

export const selectChartTab = createSelector(
  selectUI,
  (state) => state.chartTab
);

export const selectIsEventDisplayVisible = createSelector(
  selectUI,
  (state) => state.isEventDisplayVisible
);

export const selectVersionBanner = createSelector(
  selectUI,
  (state) => state.versionBanner
);

export const selectSmallScreen = createSelector(
  selectUI,
  (state) => state.smallScreen
);

export const selectShowRecentUpdates = createSelector(
  selectUI,
  (state) => state.showRecentUpdates
);